import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { CurrencyFormat } from '../../../utils';
import ModalOutOfStockModel from '../Modals/ModalOutOfStockModel'

const CardCarItem = ({model, selectedMotor}) => {
    const history = useHistory();
    const [outOfStockModalIsOpen, setOutOfStockModalIsOpen] = useState(false)

    function motorColor(model) {
        if (!model || !model.versions || !Array.isArray(model.versions)) {
            return false;
        }
        for (let i = 0; i < model.versions.length; i++) {
            const version = model.versions[i];
            
            if (version && version.motor && version.motor.color !== null) {
                return version.motor.color;
            }
        }

        return false;
    }

    function motorIcon(model){
        if (!model || !model.versions || !Array.isArray(model.versions)) {
            return false;
        }

        const version = model.versions[0];

        if (version && version.motor && version.motor.icon && version.motor.icon.url) {
            return version.motor.icon.url;
        }

        return false;
    }

    function getMotorColor() {
        if (selectedMotor && selectedMotor.id !== 0 && selectedMotor.color) {
            return selectedMotor.color;
        }
        return motorColor(model);
    }

    function getMotorIcon() {
        if (selectedMotor && selectedMotor.id !== 0 && selectedMotor.icon && selectedMotor.icon.url) {
            return selectedMotor.icon.url;
        }
        return motorIcon(model);
    }
    
    return (
        <>
            <div className="card-vehicle with-button --always-visible">
                <div className={'details-car'} style={{backgroundColor: `${getMotorColor()}20`}}>
                    {model.slogan && <span className='model-slogan'>{ model.slogan }</span>}
                    <span className='title'>
                        <h4 style={{color: `${getMotorColor()}`}}>{ model.name }</h4>
                        {getMotorIcon() && <img className="motor-icon" src={getMotorIcon()} alt="" />}
                    </span>
                </div>
                {/* <img src={'https://tcl-s3-bucket.s3.amazonaws.com/web/media/images/Yaris_Cross_NGC200L-DHXMKJ__M1_089_09_de_tam.max-380x230.png'} alt={model.name} /> */}
                <img src={model.image ? model.image.url : null} alt={ model.image? model.image.alt : null } />
                <div className='price'>
                    <p>Desde {CurrencyFormat(model.cheapest_price)}<small> (*)</small></p>
                    <small className='green-tax'>+I.V. {CurrencyFormat(model.cheapest_green_tax)}</small>
                </div>
                <div className='card-footer'>
                    {model.stock_warning ? (
                        <a
                            className='btn black'
                            title='Avisarme cuando esté disponible'
                            onClick={() => {
                                setOutOfStockModalIsOpen(true);
                            }}>
                            Avísame
                        </a>
                    ) : (
                        <a
                            className='btn red'
                            onClick={() => {
                                if(dataLayer) {
                                    dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'Cotizador',
                                        'eventAction': 'Cotizar',
                                        'eventLabel': model.name
                                    });
                                }
                                history.push(
                                    `/configurar/${model.cheapest_version}`
                                );
                            }}>
                            Cotizar
                        </a>
                    )}
                    {model.model_page && (
                        <a className='btn outline-black' href={model.model_page}>
                            Ver modelo
                        </a>
                    )}
                </div>
            </div>
            <ModalOutOfStockModel 
                isOpen={outOfStockModalIsOpen} 
                onCloseModal={() => setOutOfStockModalIsOpen(false)} 
                selectedModel={model}/>
        </>
    )
}

export default CardCarItem;
